var exports = {
  "k": "container__uc9Mwu",
  "p": "iframe__lM8wlD",
};

module.exports = exports;
